import { useCallback } from 'react';
import { Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';

export const useScanToPayNavigation = (closeModal: () => void) => {
  const navigation = useNavigation();

  const goToSgRewards = useCallback(() => {
    closeModal();
    navigation.navigate('MainTabs', {
      screen: 'LoyaltyTab',
      params: {
        screen: 'LoyaltyHome',
      },
    });
  }, [navigation, closeModal]);

  const goToForgotToScan = useCallback(() => {
    closeModal();
    navigation.navigate('Modal', {
      screen: 'ForgotToScan',
    });
  }, [navigation, closeModal]);

  const goToSupport = useCallback(() => {
    closeModal();
    navigation.navigate('Modal', {
      screen: 'Chat',
    });
  }, [navigation, closeModal]);

  const goToPayments = useCallback(() => {
    closeModal();
    navigation.navigate('Modal', {
      screen: 'Payments',
      params: { redirectTo: `https://${host}/scan-at-checkout` },
    });
  }, [navigation, closeModal]);

  const goBack = useCallback(() => {
    closeModal();
    navigation.goBack();
  }, [navigation, closeModal]);

  return {
    goToSgRewards,
    goToForgotToScan,
    goToSupport,
    goToPayments,
    goBack,
  };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const host = Platform.select({
  web: window.location.host,
  default: 'order.sweetgreen.com',
});
